import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-explorer",
  templateUrl: "./med-icon-explorer.component.html",
})
export class MedIconExplorerComponent extends SvgMixinComponent {}
